export default function parseOverrideString(override: string): { [index: string]: boolean } {
    let overrides = {};

    override.split(',').forEach(override => {
        // default on, case where there is no qualifier
        let enabled = true;

        // if there is a qualifier, then remove it and set enabled bit based on it
        if (override.indexOf('-') === 0) {
            enabled = false;
            override = override.slice(1, override.length);
        }

        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS7053 (17,9): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        // @ts-expect-error
        overrides[override.toLowerCase()] = enabled;
    });

    return overrides;
}
